if ( typeof ShippingNotice !== 'function' ) {

  class ShippingNotice extends HTMLElement {

    constructor() {
      super();
      this.init();
    }

    init() {
      const freeShippingThreshold = Number(this.getAttribute('data-free-shipping'));
      const cartTotal = Number(this.getAttribute('data-cart-total'));
      const freeShippingRemaining = freeShippingThreshold - cartTotal;
			
      let cartSliderWidth = 0;
      if ( freeShippingRemaining > 0 ) {
        const remainingFormatted = this.getAttribute('data-remaining-formatted') || '';
        this.querySelector('[data-js-free-shipping-text]').innerHTML = window.KROWN.settings.locales.shipping_notice_remaining_to_free.replace('{{ remaining_amount }}', remainingFormatted);
        cartSliderWidth = (cartTotal / freeShippingThreshold) * 100;
      } else {
        this.querySelector('[data-js-free-shipping-text]').innerHTML = window.KROWN.settings.locales.shipping_notice_eligible_for_free;
        cartSliderWidth = 100;
      }
      
      // Ensure the slider width is between 0 and 100
      cartSliderWidth = Math.max(0, Math.min(100, cartSliderWidth));
      
			if ( this.querySelector('[data-js-free-shipping-slider]') ) {
				this.querySelector('[data-js-free-shipping-slider]').style.width = `${cartSliderWidth}%`;
			}

      // Initialize milestones if they exist
      this._initMilestones(freeShippingThreshold, cartTotal);
    }
    
    _initMilestones(freeShippingThreshold, cartTotal) {
      // Check if milestones exist in data attribute
      const milestonesAttr = this.getAttribute('data-milestones');
      if (!milestonesAttr) return;
      
      try {
        // Parse milestones from attribute (format: JSON array of milestone objects)
        const milestones = JSON.parse(milestonesAttr);
        if (!Array.isArray(milestones) || milestones.length === 0) return;
        
        // Get the slider container
        const sliderContainer = this.querySelector('[data-js-free-shipping-slider]')?.parentNode;
        if (!sliderContainer) return;
        
        // Clear any existing milestone elements
        const existingMilestones = this.querySelectorAll('.shipping-notice-milestone');
        existingMilestones.forEach(milestone => milestone.remove());
        
        // Create and position each milestone
        milestones.forEach(milestone => {
          // Validate milestone data
          if (!milestone.position || milestone.position < 0 || milestone.position > 100) return;
          
          // Create milestone container
          const milestoneEl = document.createElement('div');
          milestoneEl.className = 'shipping-notice-milestone';
          milestoneEl.style.left = `${milestone.position}%`;
          
          // Add gift icon
          const iconEl = document.createElement('div');
          iconEl.className = 'shipping-notice-milestone-icon';
          iconEl.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 12v10H4V12"></path><path d="M2 7h20v5H2z"></path><path d="M12 22V7"></path><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"></path><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"></path></svg>';
          milestoneEl.appendChild(iconEl);

		  // Add text above milestone if provided
          if (milestone.text) {
            const textEl = document.createElement('div');
            textEl.className = 'shipping-notice-milestone-text';
            textEl.textContent = milestone.text;
            milestoneEl.appendChild(textEl);
          }
          
          // Check if milestone is reached
          const milestoneAmount = (milestone.position / 100) * freeShippingThreshold;
          if (cartTotal >= milestoneAmount) {
            milestoneEl.classList.add('milestone-reached');
          }
          
          // Add to slider container
          sliderContainer.appendChild(milestoneEl);
        });
        
        // Add CSS if it doesn't exist yet
        if (!document.getElementById('shipping-notice-milestone-styles')) {
          const styleEl = document.createElement('style');
          styleEl.id = 'shipping-notice-milestone-styles';
          styleEl.textContent = `
            .shipping-notice-milestone {
              position: absolute;
              bottom: 0;
              transform: translateX(-50%) translateY(50%);
              display: flex;
              flex-direction: column;
              align-items: center;
              z-index: 2;
            }
            .shipping-notice-milestone-text {
              font-size: 12px;
              white-space: nowrap;
            }
            .shipping-notice-milestone-icon {
              width: 20px;
              height: 20px;
            }
            .shipping-notice-milestone-icon svg {
              width: 100%;
              height: 100%;
            }
            .milestone-reached .shipping-notice-milestone-icon {
              color: var(--color-accent);
            }
          `;
          document.head.appendChild(styleEl);
        }
        
      } catch (e) {
        console.error('Error parsing shipping notice milestones:', e);
      }
    }
    
  }

  if ( typeof customElements.get('shipping-notice') == 'undefined' ) {
    customElements.define('shipping-notice', ShippingNotice);
  }

}